import { render, staticRenderFns } from "./CollapsableCard.vue?vue&type=template&id=def78ba8&"
import script from "./CollapsableCard.vue?vue&type=script&lang=ts&"
export * from "./CollapsableCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports